import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  TextField,
  Typography,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import { Context } from '../context/DataContext';

const QueryPreviousOrderPage = () => {
  const navigate = useNavigate();
  const [values, setValues] = React.useState({ name: '', phone: '' });
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const { name, phone } = values;
  const {
    state: {
      loginInfo: { dealerNo },
    },
    getPreviousOrders,
  } = React.useContext(Context);

  const handleChange = (prop) => (e) =>
    setValues({
      ...values,
      [prop]: e.target.value,
    });

  return (
    <Box>
      <Typography variant="h4" sx={{ my: 2 }}>
        查詢符合條件保單
      </Typography>
      <Box
        component="form"
        sx={{ px: 3, '& > :not(style)': { my: 1 } }}
        noValidate
        autoComplete="off"
      >
        <TextField
          fullWidth
          id="user-name"
          label="姓名"
          variant="outlined"
          value={name}
          onChange={handleChange('name')}
        />
        <TextField
          fullWidth
          id="user-phone"
          type="number"
          label="電話"
          variant="outlined"
          value={phone}
          onChange={handleChange('phone')}
          inputProps={{
            inputMode: 'numeric',
          }}
        />
        {errorMsg ? (
          <Typography variant="h6" sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <Button
          variant="contained"
          sx={{ width: 168 }}
          disabled={loading}
          onClick={() => {
            if (errorMsg) setErrorMsg('');

            setLoading(true);
            getPreviousOrders(
              {
                companyNo: dealerNo,
                name,
                phone,
              },
              ({ responseCode, responseMsg }) => {
                setLoading(false);
                if (responseCode === '000') {
                  navigate('/select-previous-order');
                } else {
                  setErrorMsg(responseMsg);
                }
              }
            );
          }}
        >
          查詢
        </Button>
      </Box>
      <Backdrop
        open={loading}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
        <Typography variant="h6" sx={{ my: 2, color: '#9DDCFF' }}>
          查詢中...
        </Typography>
      </Backdrop>
    </Box>
  );
};

export default QueryPreviousOrderPage;
